import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { map, catchError, switchMap } from 'rxjs/operators';
import { RemindersAnalyticsActions } from './reminders-analytics.actions';
import { AuthActions } from '@app/store/auth/auth.actions';
import { RemindersAnalyticsApiService } from '@app/core/api/reminders-analytics';
import { LoggerService } from '@app/core/infrastructure';

@Injectable()
export class RemindersAnalyticsEffects {
  private readonly actions$ = inject(Actions);
  private readonly remindersApi = inject(RemindersAnalyticsApiService);
  private readonly logger = inject(LoggerService).scope('RemindersAnalyticsEffects');

  loadOverview$ = createEffect(() =>
    this.actions$.pipe(
      ofType(RemindersAnalyticsActions.loadOverview),
      switchMap(({ params }) =>
        this.remindersApi.getOverview(params).pipe(
          map(overview => RemindersAnalyticsActions.loadOverviewSuccess({ overview })),
          catchError(error => {
            this.logger.error('Load reminders overview failed:', error);
            return of(RemindersAnalyticsActions.loadOverviewFailure({ error: error.message }));
          })
        )
      )
    )
  );

  loadTrend$ = createEffect(() =>
    this.actions$.pipe(
      ofType(RemindersAnalyticsActions.loadTrend),
      switchMap(({ params }) =>
        this.remindersApi.getTrend(params).pipe(
          map(trend => RemindersAnalyticsActions.loadTrendSuccess({ trend })),
          catchError(error => {
            this.logger.error('Load reminders trend failed:', error);
            return of(RemindersAnalyticsActions.loadTrendFailure({ error: error.message }));
          })
        )
      )
    )
  );

  loadTracker$ = createEffect(() =>
    this.actions$.pipe(
      ofType(RemindersAnalyticsActions.loadTracker),
      switchMap(({ params }) =>
        this.remindersApi.getTracker(params).pipe(
          map(response => RemindersAnalyticsActions.loadTrackerSuccess({ tracker: response.reminders })),
          catchError(error => {
            this.logger.error('Load medicine tracker failed:', error);
            return of(RemindersAnalyticsActions.loadTrackerFailure({ error: error.message }));
          })
        )
      )
    )
  );

  clearOnLogout$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AuthActions.logout),
      map(() => RemindersAnalyticsActions.clearRemindersAnalyticsState())
    )
  );
}
